import { useEffect } from 'react';

// ใช้ class .modal-overlay/.modal-content เดิมใน index.css (dark gradient +
// fadeIn/slideUp animation ที่มีอยู่แล้ว ใช้ซ้ำใน 3 หน้า) เพิ่ม Escape-to-close และ
// body-scroll-lock ให้ทุกหน้าที่ใช้ตัวนี้ได้พฤติกรรมเดียวกันหมด แทนที่แต่ละหน้าจะ
// เขียน overlay/content ของตัวเองซ้ำกันคนละแบบ
export default function Modal({ open, onClose, title, children, closeOnBackdrop = true, maxWidth }) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    const handleKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={closeOnBackdrop ? onClose : undefined}>
      <div className="modal-content" style={maxWidth ? { maxWidth } : undefined} onClick={(e) => e.stopPropagation()}>
        {title && <h3>{title}</h3>}
        {children}
      </div>
    </div>
  );
}
